import React, { useEffect } from "react"
import Helmet from "react-helmet"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import footerStyles from 'src/styles/shared/footer.module.scss';
import styles from 'src/styles/shared/legal-pages.module.scss';


export default function Terms() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);  return (
        <HomepageLayout>
            <Helmet data={JSONData}>
                <link rel="icon" href="/img/favicon-32x32.png" sizes="32x32" />
             <title>Terms of Service | Better Screenshot</title>
            </Helmet>
            <div className={styles.legalPage}>
            <header style={{backgroundImage: "#e3dedb", borderBottom: "1px solidrgb(201, 201, 201)"}}>
            <img src="/img/betterscreen_logo2.png" alt="Better Screenshot Logo" />
                </header>
                <div className={styles.container}>
                <div
                        name="termly-embed"
                        data-id="15fd81a9-35fe-463e-89d3-21e5662ba87a"
                        data-type="iframe"
                    ></div>
                </div>
            </div>
            <RawFooter />
        </HomepageLayout>
    );
}
